import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface OverdueTaskItem {
  id: string;
  name: string;
  location: string;
  daysOverdue: number;
}

interface OverdueTasksProps {
  items?: OverdueTaskItem[];
  isLoading?: boolean;
}

export function OverdueTasks({ items, isLoading }: OverdueTasksProps) {
  const defaultItems: OverdueTaskItem[] = [
    { id: '1', name: 'Lắp đặt hệ thống thoát nước', location: 'Khu A - Tuyến 2', daysOverdue: 1 },
    { id: '2', name: 'Trồng cây bóng mát', location: 'Khu A - Tuyến 3', daysOverdue: 2 },
    { id: '3', name: 'Lắp đặt đèn sân vườn', location: 'Khu A - Tuyến 1', daysOverdue: 3 },
  ];

  const displayItems = items || defaultItems;

  return (
    <Card className="border-none shadow-sm h-full">
      <CardContent className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Công việc quá hạn</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem tất cả</button>
        </div>

        <div className="space-y-6">
          {displayItems.map((item) => (
            <div key={item.id} className="flex justify-between items-start">
              <div className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center shrink-0">
                  <i className="ri-alarm-warning-line text-red-500 text-sm" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-slate-700 truncate leading-tight mb-1">{item.name}</p>
                  <p className="text-[10px] font-medium text-slate-400 italic">{item.location}</p>
                </div>
              </div>
              <span className="text-[10px] font-bold text-red-500 whitespace-nowrap shrink-0">Quá {item.daysOverdue} ngày</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
